// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { UserIcon } from "@heroicons/react/24/outline";
// import CustomTitleAccount from "./customTitleAccount";
// import CustomInfoInput from "./customInfoInput";
// import { useTranslation } from "react-i18next";
// import { updateUserById } from "../../redux/reducer/userAddressReducer";

// import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";
// import PhoneCodeDropdown from "../sharedComponents/PhoneCodeDropdown";

// const AccountInfoSection = ({ addresses }) => {
//   const { t } = useTranslation();
//   const dispatch = useDispatch();
//   const [countryCode, setCountryCode] = useState("");
//   const [countryCodeDefualt, setCountryCodeDefualt] = useState("");
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [phone, setPhone] = useState("");
//   const [isEditing, setIsEditing] = useState(false);
//   const [userId, setUserId] = useState(null);
//   const [originalData, setOriginalData] = useState({});
//   const navigateWithLang = useLanguageNavigate();

//   useEffect(() => {
//     if (addresses) {
//       setFirstName(addresses?.firstName || "");
//       setPhone(addresses?.phone || "");
//       setOriginalData({
//         firstName: addresses?.firstName,
//         lastName: addresses?.lastName,
//         phone: addresses?.phone,
//       });
//       setUserId(addresses?._id || "");
//       setLastName(addresses?.lastName || "");
//     }
//   }, [addresses]);

//   const handleSaveClick = async () => {
//     if (!userId) {
//       console.error("User ID not found");
//       return;
//     }

//     if (
//       firstName === originalData.firstName &&
//       lastName === originalData.lastName &&
//       phone === originalData.phone
//     ) {
//       alert(t("NoChangeData"));
//       setIsEditing(false);
//       return;
//     }

//     const updatedData = {
//       firstName: firstName,
//       lastName: lastName,
//       phone: phone,
//     };

//     dispatch(updateUserById({ userId, updatedData }))
//       .unwrap()
//       .then(() => {
//         setIsEditing(false);
//         setOriginalData(updatedData);
//         navigateWithLang("/my-account");

//         window.location.reload();
//       })
//       .catch((error) => {
//         console.error("An error occurred while updating the user:", error);
//       });
//   };

//   const handleInputChange = (setter, fieldName) => (e) => {
//     const newValue = e.target.value;
//     setter(newValue);

//     const updatedFields = {
//       firstName: fieldName === "firstName" ? newValue : firstName,
//       lastName: fieldName === "lastName" ? newValue : lastName,
//       phone: fieldName === "phone" ? newValue : phone,
//     };

//     if (
//       updatedFields.firstName === originalData.firstName &&
//       updatedFields.lastName === originalData.lastName &&
//       updatedFields.phone === originalData.phone
//     ) {
//       setIsEditing(false);
//     } else {
//       setIsEditing(true);
//     }
//   };

//   // console.log(addresses);
//   return (
//     <div className="w-full mb-4">
//       <CustomTitleAccount
//         title={t("AccountInformation")}
//         onClick={isEditing ? handleSaveClick : null}
//         icon={<UserIcon className="w-8 h-8 text-black" />}
//         isEditing={isEditing}
//       />

//       {addresses && (
//         <div className="flex flex-col gap-5">
//           <div className="flex gap-3 ">
//             <CustomInfoInput
//               id="firstName"
//               label={t("FirstName")}
//               type="text"
//               value={firstName}
//               onChange={handleInputChange(setFirstName, "firstName")}
//               icon={<i className="fas fa-user"></i>}
//             />
//             <CustomInfoInput
//               id="LastName"
//               label={t("LastName")}
//               type="text"
//               value={lastName}
//               onChange={handleInputChange(setLastName, "lastName")}
//               icon={<i className="fas fa-user"></i>}
//             />
//           </div>
//           <div className="flex gap-3 ">
//             <div className="relative w-1/2">
//               <label className="block mb-2 text-sm font-semibold text-gray-700">
//                 {t("email")}
//               </label>
//               <input
//                 type="text"
//                 value={addresses?.email}
//                 readOnly
//                 className="w-full px-2 py-2 text-sm text-black bg-white border border-gray-300 rounded-lg md:px-5 sm:text-lg placeholder:text-sm"
//               />
//             </div>
//             <div className="relative w-1/2">
//               <label className="block w-full mb-2 text-sm font-semibold text-gray-700">
//                 {t("PhoneNumber")}
//               </label>
//               <div className="flex gap-2" dir="ltr">
//                 <div className="w-1/4">
//                   {/* <input
//                     type="text"
//                     value={addresses?.countryCode}
//                     readOnly
//                     className="w-full px-2 py-2 text-sm text-black bg-white border border-gray-300 rounded-lg md:px-5 sm:text-lg placeholder:text-sm"
//                   /> */}
//                   <PhoneCodeDropdown
//                     onSelect={(item) => setCountryCode(item)}
//                     countryCodeDefualt={countryCodeDefualt}
//                     // value={countryCode}
//                   />
//                 </div>
//                 <div className="w-3/4">
//                   <CustomInfoInput
//                     id="phone"
//                     // label={t("PhoneNumber")}
//                     type="text"
//                     value={phone}
//                     onChange={handleInputChange(setPhone, "phone")}
//                     icon={<i className="fas fa-phone"></i>}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AccountInfoSection;

import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { UserIcon } from "@heroicons/react/24/outline";
import CustomTitleAccount from "./customTitleAccount";
import CustomInfoInput from "./customInfoInput";
import { useTranslation } from "react-i18next";
import { updateUserById } from "../../redux/reducer/userAddressReducer";

import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";

const AccountInfoSection = ({ addresses }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [codePhone, setCodePhone] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [userId, setUserId] = useState(null);
  const [originalData, setOriginalData] = useState({});
  const navigateWithLang = useLanguageNavigate();
  // console.log(addresses);
  useEffect(() => {
    if (addresses) {
      setFirstName(addresses?.firstName || "");
      setPhone(addresses?.phone || "");
      setCodePhone(addresses?.countryCode || "");
      setOriginalData({
        firstName: addresses?.firstName,
        lastName: addresses?.lastName,
        phone: addresses?.phone,
        codePhone: addresses?.countryCode,
      });
      setUserId(addresses?._id || "");
      setLastName(addresses?.lastName || "");
    }
  }, [addresses]);

  const handleSaveClick = async () => {
    if (!userId) {
      console.error("User ID not found");
      return;
    }

    if (
      firstName === originalData.firstName &&
      lastName === originalData.lastName &&
      phone === originalData.phone &&
      codePhone === originalData.codePhone
    ) {
      alert(t("NoChangeData"));
      setIsEditing(false);
      return;
    }

    const updatedData = {
      firstName: firstName,
      lastName: lastName,
      phone: phone,
      countryCode: codePhone,
    };

    dispatch(updateUserById({ userId, updatedData }))
      .unwrap()
      .then(() => {
        setIsEditing(false);
        setOriginalData(updatedData);
        navigateWithLang("/my-account");

        window.location.reload();
      })
      .catch((error) => {
        console.error("An error occurred while updating the user:", error);
      });
  };

  const handleInputChange = (setter, fieldName) => (e) => {
    const newValue = e.target.value;
    setter(newValue);

    const updatedFields = {
      firstName: fieldName === "firstName" ? newValue : firstName,
      lastName: fieldName === "lastName" ? newValue : lastName,
      phone: fieldName === "phone" ? newValue : phone,
      codePhone: fieldName === "codePhone" ? newValue : codePhone,
    };

    if (
      updatedFields.firstName === originalData.firstName &&
      updatedFields.lastName === originalData.lastName &&
      updatedFields.phone === originalData.phone &&
      updatedFields.codePhone === originalData.codePhone
    ) {
      setIsEditing(false);
    } else {
      setIsEditing(true);
    }
  };

  // console.log(addresses);
  return (
    <div className="w-full mb-4">
      <CustomTitleAccount
        title={t("AccountInformation")}
        onClick={isEditing ? handleSaveClick : null}
        icon={<UserIcon className="w-8 h-8 text-black" />}
        isEditing={isEditing}
      />

      {addresses && (
        <div className="flex flex-col gap-5">
          <div className="flex gap-3 ">
            <CustomInfoInput
              id="firstName"
              label={t("FirstName")}
              type="text"
              value={firstName}
              onChange={handleInputChange(setFirstName, "firstName")}
              icon={<i className="fas fa-user"></i>}
            />
            <CustomInfoInput
              id="LastName"
              label={t("LastName")}
              type="text"
              value={lastName}
              onChange={handleInputChange(setLastName, "lastName")}
              icon={<i className="fas fa-user"></i>}
            />
          </div>
          <div className="flex gap-3 ">
            <div className="relative w-1/2">
              <label className="block mb-2 text-sm font-semibold text-gray-700">
                {t("email")}
              </label>
              <input
                type="text"
                value={addresses?.email}
                readOnly
                className="w-full px-2 py-2 text-sm text-black bg-white border border-gray-300 rounded-lg md:px-5 sm:text-lg placeholder:text-sm"
              />
            </div>
            <div className="relative w-1/2">
              <label className="block w-full mb-2 text-sm font-semibold text-gray-700">
                {t("PhoneNumber")}
              </label>
              <div className="flex gap-2" dir="ltr">
                <div className="w-1/4">
                  {!addresses?.user?.isWithGoogle ? (
                    <input
                      type="text"
                      value={addresses?.countryCode}
                      className="w-full px-2 py-2 text-sm text-black bg-white border border-gray-300 rounded-lg md:px-5 sm:text-lg placeholder:text-sm"
                    />
                  ) : (
                    <CustomInfoInput
                      id="codePhone"
                      // label={t("codePhone")}
                      dir="ltr"
                      placeholder={t("codePhone")}
                      type="text"
                      value={codePhone}
                      onChange={handleInputChange(setCodePhone, "codePhone")}
                      icon={<i className="fas fa-phone"></i>}
                    />
                  )}
                </div>
                <div className="w-3/4">
                  <CustomInfoInput
                    id="phone"
                    // label={t("PhoneNumber")}
                    placeholder={t("PhoneNumber")}
                    type="text"
                    value={phone}
                    onChange={handleInputChange(setPhone, "phone")}
                    icon={<i className="fas fa-phone"></i>}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountInfoSection;
